export default __webpack_public_path__ + "static/media/accesibilidad.44481da6.png";